<itec-form-file-upload
	files="vm.files"
	err-files="vm.errFiles"
	funcio-seleccionar="vm.selectFiles()"
	select-files-text="{{selectFilesText}}"
	pattern="['images']"
	multiple-files="true"
	max-size="{{vm.maxSize}}">
</itec-form-file-upload>

<div ng-repeat="f in vm.files" class="itec-file-upload tcqi--margin-top-20">
	<div ng-show="f.status!='working'">
		<div class="mdl-grid" ng-show="f.fields.selected || f.status == 'done'">
			<div class="mdl-cell mdl-cell--1-col mdl-cell--middle">
			</div>

			<div class="mdl-cell mdl-cell--11-col">
				{{::f.file.name}}
				<span flex></span>
				<md-button ng-show="f.progress==100" class="md-icon-button">
		          	<md-icon>done</md-icon>
		        </md-button>
				<md-progress-linear md-mode="determinate" value="{{f.progress}}">
				</md-progress-linear>
			</div>
		</div>
	</div>

	<form name="f.form" novalidate ng-cloak ng-show="f.status=='working'">
		<div class="mdl-grid">

			<div class="mdl-cell mdl-cell--1-col mdl-cell--middle">
				<md-checkbox class="md-primary" aria-label="mark file" ng-model="f.fields.selected"></md-checkbox>
			</div>

			<div class="mdl-cell mdl-cell--11-col">
				<itec-input-text 	name="title"
									container-class=""
									with-label="false"
			    					ng-model="f.fields.title"
							        ng-required="true"
							        ng-minlength="0"
							        ng-maxlength="255"
							        label="DEFAULT_NOM"
							        validation-message-required="DEFAULT_VALIDATION_MESSAGE_REQUIRED"
							        validation-message-minlength="DEFAULT_VALIDATION_MESSAGE_MINLENGTH"
							        validation-message-maxlength="DEFAULT_VALIDATION_MESSAGE_MAXLENGTH">
				</itec-input-text>
			</div>
		</div>
	</form>

</div>

<itec-form-file-upload-errors
  err-files="vm.errFiles"
  max-size="{{vm.maxSize}}"
  max-size-exceeded-text={{maxSizeExceededText}}>
</itec-form-file-upload-errors>

<br/><br/>

<itec-button
			ng-click-function="vm.uploadFiles()" 
			ng-disabled="vm.invalidForm()" 
			ng-show="vm.files.length>0 && vm.pending(vm.files)"
			label="{{saveFilesText}}">
</itec-button>
<itec-button
			ng-click-function="vm.cleanForm()" 
			ng-show="vm.files.length>0"
			label="DEFAULT_TORNAR">
</itec-button>